import { CustomerHistoryMediaType } from "@/common/types";
import { Client, Controller, mapUrl } from "..";
import { CustomerHistoryDto } from "../models/customerHistory";

export const customerHistoryQueryKey = "customer-history";

export const fetchCustomerHistory = (
	type: CustomerHistoryMediaType,
	interactionId: string,
	customerContactInformation: string | undefined
): Promise<CustomerHistoryDto> => {
	const url = mapUrl(
		Controller.CustomerHistoryInteractions,
		type.toString(),
		interactionId
	);

	return Client.instance.get<CustomerHistoryDto>(url, {
		customerContactInformation: customerContactInformation,
	});
};
